import * as React from 'react';

export const Filter = (props: React.SVGProps<SVGSVGElement>) => (
  <svg {...props} viewBox="0 0 12 12">
    <path
      fill="currentColor"
      d="M11.453.814a.467.467 0 0 0-.46-.304H1.006a.467.467 0 0 0-.46.304c-.088.213-.052.396.11.546l3.845 3.846v3.792c0 .135.05.252.148.35l1.997 1.998c.094.098.211.148.352.148a.543.543 0 0 0 .195-.039.466.466 0 0 0 .304-.46V5.206l3.846-3.846c.161-.15.197-.332.109-.546z"
    />
  </svg>
);
